import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { startLessonFlowSearchDefaults } from "#/modules/les.start-flow/filters";
import { LesPreparationDialog } from "#/modules/les.planning/components/les-preparation-dialog";
import {
  preparationBeforeLoad,
  preparationLayoutOptions,
} from "#/modules/les.planning/preparation-routes";
import { PlanningProvider } from "#/modules/les.planning/services/runtime";

// A les is prepared over the lesdag it was opened from, and closing goes back there.
export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/lessons/today/les",
)({
  ...preparationLayoutOptions,
  search: { middlewares: [stripSearchParams(startLessonFlowSearchDefaults)] },
  beforeLoad: ({ search, params, location, context }) =>
    preparationBeforeLoad("lesdag", { search, params, location, context }),
  component: LesdagLesPreparation,
});

function LesdagLesPreparation() {
  const params = Route.useParams();
  const navigate = Route.useNavigate();
  return (
    <PlanningProvider tenant={{ school: params.school, schoolyear: params.schoolyear }}>
      <LesPreparationDialog
        base="lesdag"
        params={params}
        search={Route.useSearch()}
        klassen={Route.useLoaderData().klassen}
        onClose={() =>
          void navigate({
            to: "/$locale/{-$schoolyear}/$school/lessons/today",
            params,
            search: (prev) => ({ date: prev.date }),
            replace: true,
            resetScroll: false,
            viewTransition: true,
          })
        }
      />
    </PlanningProvider>
  );
}
